module.exports = __webpack_public_path__ + "static/media/NathanJones.47a199f7.png";